import styled from "styled-components";

export const IconContainer = styled.section`
    display: flex;
    justify-content: center;
    gap: 50px;
    flex-wrap: wrap;
    margin-bottom: 5rem;
`;

export const Skill = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    color: rgba(255, 255, 255, 0.7);
`;